import React, { useState } from "react";
import { toast } from "react-toastify";
import { useDeleteDeliveriesAllMutation } from "../../query/delivery-query";
import { Confirm } from "../../types/confirm";
import { validateBirth } from "../../utils/validator/birth";
import { DeleteAllDialogPresenter } from "./DeleteAllDialogPresenter";

interface Props {
  handleClickDialogClose: () => void;
}

export const DeleteDeliveryAllDialogContainer: React.FC<Props> = ({
  handleClickDialogClose,
}) => {
  const [specificDate, setSpecificDate] = useState("");
  const [specificDateValidate, setSpecificDateValidate] = useState(false);
  const deleteDeliveriesAllMutation = useDeleteDeliveriesAllMutation();

  const handleChangeInputField = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSpecificDate(event.target.value);
  };

  const handleClickInitButton = () => {
    setSpecificDate("");
    setSpecificDateValidate(false);
  };

  const handleClickConfirmButton = () => {
    if (validateBirth(specificDate)) {
      setSpecificDateValidate(true);
      toast.error(Confirm.Error);
      return;
    }

    if (
      window.confirm(`${specificDate} 일자의 물류를 전부 삭제하시겠습니까?`)
    ) {
      deleteDeliveriesAllMutation.mutate(specificDate, {
        onSuccess: () => {
          handleClickDialogClose();
        },
      });
    } else {
      alert("취소되었습니다.");
    }
  };

  return (
    <DeleteAllDialogPresenter
      specificDate={specificDate}
      dialogTitle="물류 전체 삭제"
      isLoading={deleteDeliveriesAllMutation.isLoading}
      isError={specificDateValidate}
      handleChangeInputField={handleChangeInputField}
      handleClickDialogClose={handleClickDialogClose}
      handleClickInitButton={handleClickInitButton}
      handleClickConfirmButton={handleClickConfirmButton}
    />
  );
};
